module.exports = __webpack_public_path__ + "static/Glasses-Small-b2033c7d1e4ac17607997aacff84a70e.png";